<template>
    <div class="w-full h-0" :class="[original ? 'relative pt-16/9' : 'absolute top-0 pt-3/2 bg-black']">
        <div class="absolute top-0 left-0 w-full h-full">
            <iframe class="object-contain object-scale-down object-left-top absolute top-0 left-0 w-full h-full"
                    :class="{ 'opacity-30 transition-opacity active-slide:opacity-100': highlight && slide && !editMode }"
                    title="Youtube"
                    :src="`https://www.youtube.com/embed/${videoId}?playsinline=1&showinfo=0&rel=0`"
                    allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Helper from '../../libs/Helper';

@Component
export default class YtVideo extends Vue {
    @Prop({ required: true }) videoId: string;
    @Prop({ default: false, type: Boolean }) original: boolean;
    @Prop({ default: false, type: Boolean }) product: boolean;
    @Prop({ default: false, type: Boolean }) highlight: boolean;
    @Prop({ default: false, type: Boolean }) slide: boolean;
    @Prop({ default: false, type: Boolean }) editMode: boolean;
    @Prop({ default: false, type: Boolean }) author: boolean;

    performanceCookie = false;

    created() {
        this.checkCookie();
        window.addEventListener('CookiebotOnAccept', () => {
            this.checkCookie();
        });
    }

    checkCookie() {
        const cookie = Helper.getCookie('CookieConsent');
        this.performanceCookie = cookie && cookie.includes('marketing:true');
    }
}
</script>
